__turbopack_context__.v({
  "androidModal": "ikHeia_androidModal",
  "desktopModal": "ikHeia_desktopModal",
  "hasSubmitted": "ikHeia_hasSubmitted",
  "iosModal": "ikHeia_iosModal",
});
